<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-aside width="120px">
      <div class="aside-top"></div>
      <div class="title">管理客户</div>
      <div class="menu">
        <div v-for="(item, index) in menu" :key="index"
          v-if="item.permission == '' || permission.indexOf(item.permission) !== -1">
          <span class="cursor" @click="toPage(item.path)">{{ item.name }}</span>
        </div>
      </div>
    </el-aside>
    <el-main class="flex-column">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div>
            <div><span>客户信息：</span>{{ info.name }}</div>
            <div v-if="permiss.indexOf('showPhoto') !== -1"><span>联系电话：</span>{{ info.telephone }}</div>
          </div>
          <div class="line"></div>
          <div>
            <div><span>装修地址：</span>{{ info.detailedAddress }}</div>
            <div><span>合同编号：</span>{{ info.projectContractNo }}</div>
          </div>
          <div class="line"></div>
          <div>
            <div v-if="info.customerAssign"><span>业务人员：</span>{{ info.customerAssign.salesmanName }}</div>
            <div v-if="info.customerAssign"><span style="letter-spacing: 1.5px;">设 计
                师：</span>{{ info.customerAssign.designerName }}</div>
          </div>
          <div class="line"></div>
          <div>
            <div v-if="info.customerAssign"><span>预算人员：</span>{{ info.customerAssign.beName }}</div>
            <div v-if="info.customerAssign"><span>客户经理：</span>{{ info.customerAssign.cmName }}</div>
          </div>
          <div class="line"></div>
          <div>
            <div v-if="info.customerAssign"><span>项目经理：</span>{{ info.customerAssign.pmName }}</div>
            <div v-if="info.customerAssign"><span>工程监理：</span>{{ info.customerAssign.suName }}</div>
          </div>
          <div class="line"></div>
          <div v-if="permission.indexOf('electronicContract') !== -1"
            class="btn-32-border-30313a-e2 flex align-center justify-center mr-5 button"
            style="width: 150px;text-align: center" @click="openContract">
            电子合同
          </div>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7 h-0">
        <div class="flex mb-10">
          <div class="title flex align-center bg-ff flex-1 h-0">
            <div class="decoration-line mr-5"></div>
            <div class="font-16-46b8b0 font-bold">客户服务日志</div>
          </div>
          <div class="flex ml-10">
            <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
              <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
              <el-input type="text" placeholder="输入关键字" v-model="keywords" clearable
                @keyup.enter.native="searchBtn"></el-input>
            </div>
            <button class="btn-30-bg-46b8b0" @click="searchBtn">搜索</button>
          </div>
        </div>
        <div class="addBtn cursor" @click="addLog">
          <img src="/static/images/customer/chubeikehu.png" alt="">
          <div>新增日志</div>
        </div>
        <div class="hr"></div>
        <div class="log flex-1 flex-column h-0">
          <div class="log-hd flex mb-10">
            <div class="flex-1">服务日志内容</div>
            <div class="w-85">服务人员</div>
            <div class="w-140">时间</div>
            <div class="w-55">操作</div>
          </div>
          <div class="log-bd flex-1 mb-10">
            <el-scrollbar style="height: 100%;">
              <div class="mb-10" v-if="logList.length > 0" v-for="(item, index) in logList" :key="index">
                <div class="flex logItem"
                  :style="{ 'border-bottom-left-radius': item.logReplyList.length > 0 ? 0 : '4px', 'border-bottom-right-radius': item.logReplyList.length > 0 ? 0 : '4px' }">
                  <div class="flex-1 pr-10">{{ item.content }}</div>
                  <div class="w-85 font-12-b9b9b9">{{ item.operatorName }}</div>
                  <div class="w-140 font-12-b9b9b9">{{ Utils.formatTime2(item.createTime) }}</div>
                  <div class="w-55 font-12-b9b9b9"><button class="btn-16-bg-85" @click="replyLog(item)">回复</button></div>
                </div>
                <div class="reply" v-if="item.logReplyList.length > 0">
                  <div v-for="(replyItem, i) in item.logReplyList" :key="i">
                    <div>
                      <div class="font-14-b9b9b9 mb-2 font-bold">{{ replyItem.operatorName }} - 回复：</div>
                      <div class="font-12-b9b9b9 mb-5">{{ Utils.formatTime2(replyItem.createTime) }}</div>
                      <div class="font-12-b9b9b9">{{ replyItem.content }}</div>
                    </div>
                    <div class="hr-dashed" v-if="i < item.logReplyList.length - 1"></div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
          </Pagination>
        </div>
      </div>
    </el-main>
    <!--新增日志-->
    <el-dialog title="新增日志" :visible.sync="addLogVisible" width="530px" class="addLog" :close-on-click-modal="false">
      <div class="p-20">
        <el-form ref="form">
          <el-form-item>
            <div class="flex">
              <div class="font-12-30313a">日志内容：</div>
              <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入内容" v-model="addContent"
                resize="none"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <div class="btn-30-bd-85-s mr-10">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitAdd">确定新增</div>
      </div>
    </el-dialog>
    <!--回复日志-->
    <el-dialog title="回复日志" :visible.sync="replyLogVisible" width="530px" class="replyLog" :close-on-click-modal="false">
      <div class="p-20">
        <el-form ref="form">
          <el-form-item>
            <div class="flex">
              <div class="font-12-30313a">回复内容：</div>
              <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入内容" v-model="replyContent"
                resize="none"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <div class="btn-30-bd-85-s mr-10">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitReply">确定回复</div>
      </div>
    </el-dialog>

    <el-dialog title="预算管理" :visible.sync="handleVisible" width="1200px" class="handlePlan">
      <div class="p-20 flex">
        <!-- <div class="flex flex-1 mr-20 bg-f3f4f7 h-231 p-relative">
            <div class="flex-column w-100">
              <div class="flex align-center border-b-e2 p-20">
                <div class="flex-1 text-left font-bold">概算</div>
                <div class="flex flex-1 justify-end"><button :class=" 0 === onIndex ? 'btn-30-bg-46b8b0':'btn-30-border-30313a-small'" @mouseenter="enter(0)" @mouseleave="leave(0)" @click="openBudget(1)">打开</button></div>
              </div>
              <div class="p-20 flex-column text-left">
                <div class="font-12-30313a flex align-center"><div class="font-12-b9b9b9 w-min-47 mr-5 h-20">状态</div><div>概算</div></div>
                <div class="font-12-30313a flex align-center"><div class="font-12-b9b9b9 w-min-47 mr-5 h-20">预算人员</div><div>{{budgetList1.fundName ? budgetList1.fundName : '-'}}</div></div>
                <div class="font-12-30313a flex align-center"><div class="font-12-b9b9b9 w-min-47 mr-5 h-20">核算人员</div><div>{{budgetList1.auditorName ? budgetList1.auditorName : '-'}}</div></div>
                <div class="font-12-30313a flex align-center"><div class="font-12-b9b9b9 w-min-47 mr-5 h-20">创建日期</div><div>{{budgetList1.auditorTime ? Utils.formatTime(budgetList1.auditorTime):'-'}}</div></div>
                <div class="font-12-30313a flex align-center"><div class="font-12-b9b9b9 w-min-47 mr-5 h-20">最后修改</div><div>{{budgetList1.saveTime ? Utils.formatTime(budgetList1.saveTime): '-'}}</div></div>
              </div>
            </div>
            <div class="p-absolute" style="right: 0;bottom: 0"><img src="/static/images/gaisuan.png" class="icon-70" alt=""></div>
          </div> -->
        <div class="flex flex-1 bg-f3f4f7 h-231 mr-20 p-relative" v-for="(item, index) in budgetList" :key="index">
          <div class="flex-column w-100">
            <div class="flex align-center border-b-e2 p-20">
              <div class="flex-1 text-left font-bold">{{ item.name }}</div>
              <div class="flex flex-1 justify-end"><button
                  :class="index === onIndex ? 'btn-30-bg-46b8b0' : 'btn-30-border-30313a-small'" @mouseenter="enter(index)"
                  @mouseleave="leave(index)" @click="openBudget(item)">打开</button></div>
            </div>
            <div class="p-20 flex-column text-left">
              <div class="font-12-30313a flex align-center">
                <div class="font-12-b9b9b9 w-min-47 mr-5 h-20">状态</div>
                <div>正式预算</div>
              </div>
              <div class="font-12-30313a flex align-center">
                <div class="font-12-b9b9b9 w-min-47 mr-5 h-20">预算人员</div>
                <div>{{ item.obj.fundName ? item.obj.fundName : '-' }}</div>
              </div>
              <div class="font-12-30313a flex align-center">
                <div class="font-12-b9b9b9 w-min-47 mr-5 h-20">核算人员</div>
                <div>{{ item.obj.auditorName ? item.obj.auditorName : '-' }}</div>
              </div>
              <div class="font-12-30313a flex align-center">
                <div class="font-12-b9b9b9 w-min-47 mr-5 h-20">创建日期</div>
                <div>{{ item.obj.auditorTime ? Utils.formatTime(item.obj.auditorTime) : '-' }}</div>
              </div>
              <div class="font-12-30313a flex align-center">
                <div class="font-12-b9b9b9 w-min-47 mr-5 h-20">最后修改</div>
                <div>{{ item.obj.saveTime ? Utils.formatTime(item.obj.saveTime) : '-' }}</div>
              </div>
            </div>
          </div>
          <div class="p-absolute" style="right: 0;bottom: 0"><img src="/static/images/yusuan.png" class="icon-70" alt="">
          </div>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import Pagination from '../../components/Pagination'
export default {
  name: 'customerManagement',
  components: { Pagination },
  data () {
    return {
      id: null,
      parent: null,
      permission: [],
      permiss: [],
      info: {},
      menu: [{
        name: '详细信息',
        path: 'DetailInfo',
        permission: ''
      }, {
        name: '计划提醒',
        path: 'PlanToRemind',
        permission: 'plan'
      }, {
        name: '图纸资料',
        path: 'Drawings',
        permission: 'file'
      }, {
        name: '预/结算',
        permission: 'budget'
      }, {
        name: '客户收款',
        path: 'CustomerPayment',
        permission: 'customerReceivables'
      }, {
        name: '工程付款',
        path: 'ProjectLoan',
        permission: 'projectPayment'
      }, {
        name: '客户提成',
        path: 'Commission',
        permission: 'commission'
      }, {
        name: '工程进度',
        path: 'ProjectProgress',
        permission: 'projectProgress'
      }, {
        name: '客户回访',
        path: 'CustomerReturn',
        permission: 'customerReturn'
      }, {
        name: '客户投诉',
        path: 'CustomerComplaint',
        permission: 'customerComplaint'
      }, {
        name: '售后维修',
        path: 'AftersaleMaintenance',
        permission: 'aftersaleMaintenance'
      }],
      handleVisible: false,
      onIndex: -1,
      keywords: null,
      page: 1,
      limit: 25,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 25,
      total: 0,
      logList: [],
      addLogVisible: false,
      addContent: null,
      replyId: null,
      replyLogVisible: false,
      replyContent: null,
      budgetList: [
        {
          name: '基装报价',
          group: 1,
          obj: {}
        },
        {
          name: '主材报价',
          group: 2,
          obj: {}
        },
        {
          name: '电器报价',
          group: 3,
          obj: {}
        },
        {
          name: '定制报价',
          group: 4,
          obj: {}
        }
      ]
    }
  },
  created () { },
  mounted () {
    this.id = this.$route.query.id
    this.parent = this.$route.query.parent
    this.$store.dispatch('setBudgetGroupId', null)
    this.getPermission()
    this.getInfo()
  },
  activated () {
  },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'customerFunction',
        parentGroup: 'customerFunction'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/getSubmitButtonStr`, {
        parent: this.parent
      }).then(res => {
        if (res.data.success) {
          this.permiss = res.data.data.split(',')
        }
      })
    },
    openContract () {
      // window.open('https://jhj-erp.oss-cn-beijing.aliyuncs.comjlf/other/%E6%A0%87%E5%87%86%E5%B7%A5%E7%A8%8B%E6%96%BD%E5%B7%A5%E5%90%88%E5%90%8C%E5%86%85%E9%A1%B520171009%E6%94%B9%E5%AE%9A%EF%BC%882.0%E8%8C%83%EF%BC%89(1)(1).pdf')
    },
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
          this.getLogList()
        }
      })
    },
    getLogList () {
      this.axios.post(`${this.$store.state.API_URL_9010}/log/queryForPage`, {
        customerId: this.id,
        page: this.page,
        limit: this.limit,
        keywords: this.keywords
      }).then(res => {
        if (res.data.success) {
          this.logList = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        }
      })
    },
    searchBtn () {
      this.page = 1
      this.getLogList()
    },
    addLog () {
      this.addLogVisible = true
    },
    submitAdd () {
      if (this.addContent === null || this.addContent === '') {
        this.$message({
          message: '请填写日志内容',
          type: 'warning'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/log/save`, {
          customerId: this.id,
          content: this.addContent
        }).then(res => {
          if (res.data.success) {
            this.getLogList()
            this.addLogVisible = false
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.addContent = ''
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    submitReply () {
      if (this.replyContent === null || this.replyContent === '') {
        this.$message({
          message: '请填写回复内容',
          type: 'warning'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/logReply/save`, {
          logId: this.replyId,
          content: this.replyContent
        }).then(res => {
          if (res.data.success) {
            this.getLogList()
            this.replyLogVisible = false
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.replyContent = ''
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    replyLog (item) {
      this.replyId = item.id
      this.replyLogVisible = true
    },
    toPage: function (path) {
      if (!path) {
        this.handleVisible = true
        this.getBudget(path)
      } else {
        this.$router.push({ name: path, query: { id: this.id, parent: this.parent } })
      }
    },
    getBudget () {
      let params = {
        customerId: this.info.id
      }
      this.axios.post('budget/list', params).then(res => {
        if (res.data.success) {
          if (res.data.data.length > 0) {
            for (var i = 0; i < res.data.data.length; i++) {
              for (var j = 0; j < this.budgetList.length; j++) {
                if (res.data.data[i].group === this.budgetList[j].group) {
                  this.budgetList[j].obj = res.data.data[i]
                }
              }
            }
          }
        }
      })
    },
    enter (a) {
      this.onIndex = a
    },
    leave () {
      this.onIndex = -1
    },
    openBudget (item) {
      this.$store.dispatch('setBudgetGroupId', item.obj.id)
      this.$router.push({ name: 'ManagerBudget', query: { id: this.id, parent: this.parent, budgetGroupId: item.obj.id, group: item.group, budgetName: item.name } })
    },
    onClose () {
      this.$router.go(-1)
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getLogList()
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getLogList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  position: relative;
}

.el-main {
  padding: 0;
}

.aside-top {
  height: 5px;
  background: #46b8b0;
  width: 100%;
}

.el-aside .title {
  background: #f3f4f7;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  color: #30313a;
}

.customerInfo {
  width: 100%;
  height: 50px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  color: #30313a;
  text-align: left;
  padding-left: 20px;
  position: relative;
}

.close {
  width: 50px;
  height: 50px;
  background: #ff5555;
}

.menu>div {
  color: #30313a;
  font-size: 14px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: dashed 1px #e2e2e2;
}

.customerInfo span {
  color: #b9b9b9;
}

.line {
  height: 32px;
  background: #f3f4f7;
  width: 1px;
  margin: 0 20px;
}

.hr {
  width: 100%;
  height: 1px;
  background: #e2e2e2;
  margin: 10px 0;
}

.hr-dashed {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #e2e2e2;
  margin: 12px 0;
}

.content {
  padding: 10px 20px;
}

.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}

.content .title {
  height: 30px;
  padding-left: 10px;
  border-radius: 4px;
}

.border-ra {
  border-radius: 4px;
}

.border-e2 {
  border: 1px solid #e2e2e2;
}

.search {
  overflow: hidden;
}

.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}

.addBtn {
  background: #fff;
  width: 85px;
  height: 24px;
  color: #30313a;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border-radius: 4px;
}

.w-85 {
  width: 85px;
}

.w-140 {
  width: 140px;
}

.w-55 {
  width: 55px;
}

.w-233 {
  width: 233px;
}

.log-hd {
  text-align: left;
  font-size: 12px;
  color: #b6b6b6;
  padding: 0 10px;
}

.log-bd {
  text-align: left;
  font-size: 12px;
  color: #424142;
  overflow-y: auto;
}

.log-bd /deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

.logItem {
  background: #fff;
  border-radius: 4px;
  padding: 10px;
}

.reply {
  background: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top: 1px solid #e2e2e2;
  padding: 15px;
  color: #b9b9b9;
}

.addLog /deep/ .el-textarea__inner,
.replyLog /deep/ .el-textarea__inner {
  padding-left: 10px;
  padding-right: 10px;
  height: 240px;
}

.h-231 {
  height: 231px;
}

.btn-30-border-30313a-small :hover {
  background: #46b8b0;
  color: #ffffff;
}

.w-min-47 {
  min-width: 47px;
  text-align: justify;
}

.w-min-47:after {
  content: ' ';
  display: inline-block;
  width: 100%;
}

.h-20 {
  height: 20px;
}

.budget :active {
  background: #46b8b0;
  color: #ffffff;
  border: 1px solid #46b8b0;
}

.budget :hover {
  background: #46b8b0;
  color: #ffffff;
  border: 1px solid #46b8b0;
}</style>



// WEBPACK FOOTER //
// src/pages/customer/customerManagement.vue